<template>
  <div class="video-container">
    <h1>视频分片加载</h1>
    <video v-if="videoUrl" controls ref="video" @play="handlePlay" @pause="handlePause">
      <source :src="videoUrl" type="video/mp4" />
      您的浏览器不支持视频播放。
    </video>
    <div v-else>加载中...</div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      videoUrl: '',
      videoLength: 0,  // 视频总长度
      chunkSize: 1024 * 1024 * 5,  // 分片大小 5MB（更大一些）
      startByte: 0,  // 当前请求的起始字节
      endByte: 0,  // 当前请求的结束字节
    };
  },
  created() {
    this.getVideoUrl();
  },
  methods: {
    // 获取视频 URL，假设视频 URL 来自后台
    getVideoUrl() {
      this.videoUrl = "http://localhost:8001/api/video/nezha2.mp4";  // 替换为实际的 API 地址
      // this.videoUrl = "http://localhost:8001/video/stream";
      this.getVideoInfo();
    },

    // 获取视频总长度
    async getVideoInfo() {
      try {
        const response = await axios.head(this.videoUrl);
        this.videoLength = parseInt(response.headers['content-length']);
        this.endByte = this.videoLength - 1;  // 设置结束字节
      } catch (error) {
        console.error("获取视频信息失败:", error);
      }
    },

    // 视频开始播放时触发
    handlePlay() {
      this.loadNextChunk();  // 开始加载视频
    },

    // 加载下一个视频分片
    async loadNextChunk() {
      if (this.startByte >= this.videoLength) return;  // 如果已经加载完所有分片，停止

      const range = `bytes=${this.startByte}-${this.endByte}`;
      try {
        const response = await axios.get(this.videoUrl, {
          headers: {'Range': range},
          responseType: 'arraybuffer',
        });

        const blob = new Blob([response.data], {type: 'video/mp4'});
        const videoBlobUrl = URL.createObjectURL(blob);

        // 更新视频播放源
        this.$refs.video.src = videoBlobUrl;

        // 更新字节范围
        this.startByte = this.endByte + 1;
        this.endByte = Math.min(this.startByte + this.chunkSize - 1, this.videoLength - 1);

        // 如果视频未播放完，继续加载下一分片
        if (this.startByte < this.videoLength) {
          this.loadNextChunk();
        }
      } catch (error) {
        console.error("加载视频分片失败:", error);
      }
    },
  },
};
</script>

<style scoped>
.video-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  flex-direction: column;
}

video {
  width: 80%; /* 设置视频宽度为页面的80% */
  max-height: 80vh; /* 限制视频最大高度为视口的80% */
}
</style>
